import { useState } from 'react';

import { NotificationsOutlined, VideocamOutlined } from '@mui/icons-material';
import { AiOutlineCalculator } from 'react-icons/ai';

import { initialToggleObj } from '../MenuDrawer/initialStates';
import { IToggleObj } from '../MenuDrawer/type';
import useSurvey from 'store/survey/useSurvey';
import usePatient from 'store/patient/usePatient';
import useStudent from 'store/student/useStudent';
import useNotification from 'hooks/useNotification';
import {
  Box,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

const Header = () => {
  const [toggle, setToggle] = useState<IToggleObj>(initialToggleObj);
  const { student_uuid } = useStudent();
  const { patientInfo } = usePatient();
  const { onRequired } = useNotification();
  const { onUpdateSurveyType } = useSurvey();

  const onClickListItem = (label: string) => {
    if (!student_uuid) return onRequired('REQUIRED.STUDENT');

    if (label === '病人安全通報與學習系統') {
      window.open('https://psnet.ahrq.gov/');
      return;
    } else if (label === '藥物不良反應通報系統') {
      window.open('https://who-umc.org/');
      return;
    } else if (label === 'Chat\nGPT') {
      window.open('https://chat.openai.com/chat');
      return;
    } else if (label === 'Google\nGemini') {
      window.open('https://bard.google.com/');
      return;
    } else if (label === '通知') {
      window.open('https://smartenr.com/notice');
      return;
    }

    if (!patientInfo) return onRequired('REQUIRED.PATIENT');
    onUpdateSurveyType(label);
  };

  const menu = [
    {
      icon: <AiOutlineCalculator />,
      label: '藥物計算器',
    },
    {
      icon: <VideocamOutlined />,
      label: '影片上傳',
    },
    {
      icon: <NotificationsOutlined />,
      label: '通知',
    },
  ];

  return (
    <Box
      sx={{
        display: 'flex',
        direction: 'row',
        witdh: '700px',
      }}
    >
      {menu.map(({ icon, label }) => {
        const onClick = () => {
          onClickListItem(label);
        };

        return (
          <ListItem
            key={label}
            disablePadding
            ref={null}
            sx={{ whiteSpace: 'pre-wrap' }}
          >
            <ListItemButton
              onClick={onClick}
              sx={{
                display: 'block',
                width: label === '通知' ? '90px' : '130px',
                height: '30px',
                padding: '0px',
                alignItems: 'center',
                borderRadius: '8px',
                margin: '1px',
              }}
            >
              <Box sx={{ display: 'flex' }}>
                <ListItemIcon
                  className="HeadName"
                  sx={{
                    margin: '6px 0 6px 0',
                    justifyContent: 'center',
                  }}
                >
                  {icon}
                </ListItemIcon>
                <ListItemText
                  primaryTypographyProps={{
                    fontSize: '12px',
                    textAlign: 'center',
                    width: '100px',
                  }}
                  primary={label}
                />
              </Box>
            </ListItemButton>
          </ListItem>
        );
      })}
    </Box>
  );
};

export default Header;
